<div class="clear"></div>
<div class="top-actions" id="top-actions">

    <div class="train-box noselect">
        <!-- <lms-train-svg *ngIf="selectedTab?.subTypeDetail[selectedTab?.subType?.toLowerCase()]?.status === 'loaded' || selectedTab?.subTypeDetail[selectedTab?.subType?.toLowerCase()]?.status === 'refresh'" [trainData]='{trainIdentifier: selectedTab?.tabSearchParameter?.searchText}'
            [screenName]="'Train'"></lms-train-svg> -->
        <span class="locoIcon-warning" *ngIf="selectedTab?.subTypeDetail[selectedTab?.subType?.toLowerCase()]?.status === 'loaded'">{{selectedTab?.tabSearchParameter?.searchText}}</span>
        <!--<span class="loco-tag" *ngIf="selectedTab?.subTypeDetail[selectedTab?.subType?.toLowerCase()]?.status === 'loaded'">{{selectedTab?.tabSearchParameter.searchText}}</span>-->
        <span class="train-na-icon" *ngIf="selectedTab?.subTypeDetail[selectedTab?.subType?.toLowerCase()]?.status !== 'loaded'">NA</span>
    </div>

    <lms-header-sub-types [subTypes]="subTypes" [tab]="selectedTab" [tabIndex]='tabLevel'></lms-header-sub-types>
    <lms-lms-history-header-sub-type [historyOps]='historyOps' [tabIndex]='tabLevel + 5' (historyTypeValueChange)='historyTypeValueChangeListner($event);'></lms-lms-history-header-sub-type>


</div>